import React from "react";
import { useSignal } from "@preact/signals-react";
import { BaseUploadNodeProps } from "imagica-uikit/dist/nodesV2/typing";
import { useDidMount } from "imagica-uikit/dist/hooks/useDidMount";
import styles from "./UnStructured.module.scss";
import cls from "classnames";
import { UnStructuredUtil } from "./UnStructuredUtil";
import { tryPromise } from "imagica-corekit/dist/base/cutil/LangUtil";
import func from "@uikit/func";
import { useStartNode } from "@custom-hooks/useNodePreview";
import { useSelector } from "react-redux";

export function UnStructured(props: BaseUploadNodeProps) {
  const file = useSignal<any[]>([]);

  const { isStartNode, isStartNodeAdded } = useStartNode(props.id);
  const disableAddPreview = useSelector((state: any) => state.fot.disableAddPreview);

  useDidMount(async () => {
    const result = await tryPromise(UnStructuredUtil.readContent(props.createBlobUrl?.fileBlob));
    if (!result.data) {
      return;
    }

    file.value = result.data;
  });
  const UnStructuredCls = cls(
    styles.UnStructured,
    "nowheel",
    !disableAddPreview && isStartNode && !isStartNodeAdded && !props.isStaticApp ? styles.reservedButtonHeight : ""
  );
  return (
    <div className={UnStructuredCls}>
      {func.isEmpty(file.value)
        ? null
        : file.value.map((item: any, index: number) => {
            return (
              <div key={item.text + index}>
                {item.text}
                {item.type && `(${item.type})`}
              </div>
            );
          })}
    </div>
  );
}
